
export default function IllustrationSection() {
  return (
    <div className="py-4 md:py-0 max-w-7xl mx-auto px-4 md:px-0">
      <h2 className="text-xl md:text-4xl font-bold text-gray-900 mb-4">
        What is Online Casino Australia?
      </h2>
      <div className="rounded-lg overflow-hidden mb-6">
        <img
          src="/202512169653219.png"
          alt="Online Casino Australia Illustration"
          className="w-full h-full object-contain"
        />
      </div>
      <div className="space-y-6">
        <p className="text-base text-gray-700 leading-relaxed">
          Online casinos in Australia represent a digital evolution of traditional brick-and-mortar gambling establishments, offering players the convenience of accessing thousands of casino games from the comfort of their homes or on mobile devices. These platforms provide a comprehensive gaming experience that includes classic table games like blackjack, roulette, and baccarat, alongside modern video slots, progressive jackpots, and live dealer games that stream real-time action directly to your screen.
        </p>

        <p className="text-base text-gray-700 leading-relaxed">
          All reputable online casinos utilize Random Number Generator (RNG) technology to ensure fair and unbiased game outcomes. This sophisticated software algorithm generates random results for each game round, whether it is a slot spin, card deal, or roulette wheel spin. Independent testing agencies regularly audit these RNG systems to verify their integrity and fairness, providing players with confidence that every game outcome is genuinely random and not manipulated in favor of the house beyond the standard mathematical house edge inherent to each game.
        </p>
      </div>
    </div>
  );
}
